import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { settingService } from "../../../services/extensions";
import { Dropdown } from "primereact/dropdown";
import { SplitButton } from "primereact/splitbutton";
import { Toolbar } from "primereact/toolbar";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import AddCustomerForm from "./customer-form";
import { InputText } from "primereact/inputtext";
import { Util } from "../../../services";
import ImportPopup from "../importpopup/importPop";

function Customers() {
  const [customers, setCustomers] = useState([]);
  const [selectLegalEntity, setSelectLegalEntity] = useState([]);
  const [allCustomers, setAllCustomers] = useState([]);
  const [customerDialog, setCustomerDialog] = useState(false);
  const [importDialog, setImportDialog] = useState(false);
  const dt = useRef(null);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    getCustomers();
  }, []);

  const getCustomers = () => {
    settingService.getCustomers().then((resp) => {
      setCustomers(resp.data.data);
      setAllCustomers(resp.data.data);
    });
  };

  const fetchStatus = (status) => {
    if (status === 0) return "INACTIVE";
    if (status === 1) return "ACTIVE";
    if (status === 2) return "REJECT";
    if (status === 3) return "UPCOMING";
    if (status === 4) return "ARCHIVE";
  };

  const fetchStatusColor = (status) => {
    if (status === 0) return "red";
    if (status === 1) return "#008000";
    if (status === 2) return "red";
    if (status === 3) return "#cb7205";
    if (status === 4) return "rgb(222 204 90)";
  };

  const statusBodyTemplate = (data) => {
    return (
      <span style={{ color: fetchStatusColor(data.status), borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>{fetchStatus(data.status)}</span>
    );
  };

  const filterLegalEntity = (data, allCustomers) => {
    setSelectLegalEntity(data);
    let customerFilter = allCustomers.filter((item) => {
      return item.legalEntityId === data.legalEntityId;
    });
    setCustomers(customerFilter);
  };

  const editRowComplete = (e) => {
    let _customer = [...customers];
    let { newData, index } = e;
    _customer[index] = newData;

    let param = {
      id: _customer[index].id,
      code: _customer[index].code,
      title: _customer[index].title,
      status: _customer[index].status,
    };

    try {
      settingService.updateCustomer(param).then(
        (resp) => {
          if (resp) {
            toast.success("Customer updated successfully!");
            getCustomers();
          }
        },
        (err) => {
          toast.error("Unable to update customer");
        }
      );
    } catch (error) {
      toast.error("Unable to update customer");
    }
  };

  const exportExcel = () => {
    Util.exportExcel(customers, "customers");
  };

  const exportCSV = (selectionOnly) => {
    dt.current.exportCSV({ selectionOnly });
  };

  const cols = [
    { field: "id", header: "Id" },
    { field: "code", header: "Code" },
    { field: "title", header: "Title" },
    { field: "status", header: "Status" },
  ];

  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const exportPdf = () => {
    Util.exportAsPdf(exportColumns, customers, "Customers");
  };

  const items = [
    {
      label: "CSV",
      icon: "pi pi-file-export",
      command: () => {
        exportCSV();
      },
    },
    {
      label: "EXCEL",
      icon: "pi pi-file-excel",
      command: () => {
        exportExcel();
      },
    },
    {
      label: "PDF",
      icon: "pi pi-file-pdf",
      command: () => {
        exportPdf();
      },
    },
  ];

  const onClickDeallocation = (rowData) => {
    setImportDialog(true);
  }
  const onHideImport = () => {
    setImportDialog(false);
  };

  const OpenimportDialog = () => {
    return (
      <Dialog className="pop-up-dialog" header="Import" footer={<Button label="Submit"></Button>} visible={importDialog} onHide={() => onHideImport()}>
        <ImportPopup
          onClose={(e) => {
            setImportDialog(false);
          }}
          type="Customer" />
      </Dialog>
    );
  };

  /* FOR CONFIRMATION DIAGOG BOX */
  const [isConfirmDialogVisiable, setIsConfirmDialogVisiable] = useState(false);
  const reject = () => {
    setIsConfirmDialogVisiable(true);
  };
  /* FOR CONFIRMATION DIALOG BOX */

  const deleteConfirm = () => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => acceptFunc(),
      reject,
    });
  };
  const acceptFunc = () => {
    var customerIdList = [];
    selectedCustomers.map((item, key) => {
      // customerIdList.push(item.id);
      customerIdList[key] = item.id;
    });
    let param = {
      Ids: customerIdList,
    };
    try {
      settingService.deleteAllCustomer(param).then(
        (resp) => {
          toast.success("Customer deleted");
          setSelectedCustomers([]);
          getCustomers();
        },
        (err) => {
          toast.error(err.response.data.error);
          setSelectedCustomers([]);
        }
      );
    } catch (error) {
      toast.error("Unable to delete customer");
    }
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="New"
          icon="pi pi-plus"
          className="p-button mr-2"
          onClick={() => addCustomer()}
        ></Button>
        <Button
          type="button"
          label="Delete"
          icon="pi pi-trash"
          className="p-button-danger"
          disabled={disabled}
          onClick={deleteConfirm}
        ></Button>
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          label="Import"
          icon="pi pi-plus"
          className="mr-2 inline-block"
          onClick={() => {
            onClickDeallocation(rowData);
          }}
        />
        <SplitButton
          label="Export"
          icon="pi pi-download"
          className="p-button-info"
          model={items}
          appendTo="self"
        />
      </React.Fragment>
    );
  };

  const rightDropdownTemplate = () => {
    return (
      <React.Fragment>
        <div className="mt-3 mr-3">
          <h3>Select Customer</h3>
        </div>
        <Dropdown
          filter
          style={{ width: "250px" }}
          placeholder="Select Customer"
          optionLabel="title"
          options={allCustomers}
          value={selectLegalEntity}
          onChange={(e) => filterLegalEntity(e.value, allCustomers)}
          appendTo="self"
        ></Dropdown>
      </React.Fragment>
    );
  };

  const addCustomer = () => {
    setCustomerDialog(true);
  };

  const onHide = () => {
    setCustomerDialog(false);
  };

  const closeCustomerDialog = () => {
    setCustomerDialog(false);
    getCustomers();
  };

  const NewCustomerDialog = () => {
    return (
      <Dialog
        // style={{ width: "30vw" }}
        className="modal_width"
        header="Add Customer"
        visible={customerDialog}
        onHide={() => onHide()}>
        <AddCustomerForm
          onClose={(e) => {
            closeCustomerDialog();
          }} />
      </Dialog>
    );
  };

  const codeEditor = (options) => {
    return (
      <InputText value={options.value} onChange={(e) => options.editorCallback(e.target.value.toUpperCase())}></InputText>
    );
  };

  const titleEditor = (options) => {
    return (
      <InputText value={options.value} onChange={(e) => options.editorCallback(e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1))}></InputText>
    );
  };

  const statuses = [
    { label: "INACTIVE", value: 0 },
    { label: "ACTIVE", value: 1 },
    { label: "ARCHIVE", value: 4 },
  ];

  const statusEditor = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={statuses}
        optionLabel="label"
        optionValue="value"
        onChange={(e) => options.editorCallback(e.value)}
        placeholder="Select a Status"
        itemTemplate={(option) => {
          return (
            <span className={`product-badge status-${option.label.toLowerCase()}`}>{option.label}</span>
          );
        }} />
    );
  };

  const deleteCustomer = (e, row) => {
    confirmDialog({
      target: e.currentTarget,
      message: "Are you sure you want to delete?",
      header: "Delete Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "No",
      rejectLabel: "Yes",
      reject: () => {
        settingService.deleteCustomerById(row.id).then(
          (resp) => {
            toast.success("Customer deleted successfully!");
            getCustomers();
          },
          (error) => { }
        );
      },
      accept: () => { },
    });
  };

  const deleteCustomerByRow = (row) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger"
          onClick={(e) => deleteCustomer(e, row)}
        ></Button>
      </React.Fragment>
    );
  };

  const onCheckCustomers = (e) => {
    setSelectedCustomers(e.value);
    if (e.value.length > 0) {
      setDisabled(false);
    }
  };

  return (
    <div>
      <div>
        <Toolbar
          className="mb-2"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        ></Toolbar>
      </div>
      <div>
        <Toolbar
          className="mb-2"
          left=""
          right={rightDropdownTemplate}
        ></Toolbar>
      </div>
      <div className="grid">
        <div className="col-12">
          <DataTable
            value={customers}
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
            editMode="row"
            onRowEditComplete={editRowComplete}
            ref={dt}
            selectionMode="checkbox"
            selection={selectedCustomers}
            onSelectionChange={(e) => onCheckCustomers(e)}>
            <Column
              selectionMode="multiple"
              headerStyle={{ width: "3rem" }}
            ></Column>
            <Column
              field="code"
              header="Code"
              headerStyle={{ width: "8rem" }}
              sortable
              editor={(options) => codeEditor(options)}
            ></Column>
            <Column
              field="title"
              header="Title"
              headerStyle={{ width: "8rem" }}
              sortable
              editor={(options) => titleEditor(options)}
            ></Column>
            <Column
              field="status"
              header="Status"
              headerStyle={{ width: "8rem" }}
              sortable
              body={statusBodyTemplate}
              editor={(options) => statusEditor(options)}
              style={{ width: "20%" }}
            ></Column>
            <Column
              rowEditor
              headerStyle={{ width: "10%", minWidth: "8rem" }}
              bodyStyle={{ textAlign: "right" }}
            ></Column>
            <Column
              rowEditor
              style={{ minWidth: "8rem" }}
              exportable={false}
              body={deleteCustomerByRow}
              headerStyle={{ width: "10%", minWidth: "8rem" }}
            ></Column>
          </DataTable>
        </div>
      </div>
      {OpenimportDialog()}
      {NewCustomerDialog()}
    </div>
  );
}

export default Customers;